import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capacitacion',
  templateUrl: './capacitacion.component.html',
  styleUrls: ['./capacitacion.component.css']
})
export class CapacitacionComponent implements OnInit {

  menuMostrar = "";
  showCapacitacionDistancia:boolean;
  showCapacitacionTutorias:boolean;

  constructor() { }

  ngOnInit(): void {
    this.menuMostrar='inicio';
    this.showCapacitacionDistancia = false
    this.showCapacitacionTutorias = false
  }



}
